import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider, useSite } from "./context/SiteContext";
import PublicSite from "./pages/PublicSite";
import AdminRoot from "./pages/admin/AdminRoot";
import ReviewPage from "./pages/ReviewPage";
import { Toaster } from "./components/ui/sonner";

function AdminRouteWrapper() {
  const { reload } = useSite();
  return <AdminRoot onSiteReload={reload} />;
}

export default function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin/*" element={<AdminRouteWrapper />} />
            <Route path="/review/:token" element={<ReviewPage />} />
            <Route path="/" element={<PublicSite />} />
            <Route path="*" element={<PublicSite />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          toastOptions={{
            style: {
              background: "#0f0d0c",
              border: "1px solid rgba(201,169,97,0.3)",
              color: "#f4ede4",
            },
          }}
        />
      </SiteProvider>
    </div>
  );
}
